enum DrawingModes {
    Point = 0,
    Polygon = 1,
    MultiLineString = 2
}


export default DrawingModes;